import { Component, inject } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { NavigationService } from '@services/navigation/navigation.service';
import { BreakpointService } from '@services/breakpoint/breakpoint.service';
import { Base } from '@shared/components/base/base';
import { LoaderComponent } from '@shared/components/loader/loader.component';
import { ToastComponent } from 'cve-ui';

@Component({
    selector: 'app-root',
    imports: [RouterOutlet, LoaderComponent, ToastComponent],
    templateUrl: './app.html',
    styleUrl: './app.scss',
})
export class App extends Base {
    breakpointService = inject(BreakpointService);
    private readonly navigationService = inject(NavigationService);

    constructor() {
        super();
        this.breakpointService.set();
    }
}
